module.exports = __webpack_public_path__ + "static/media/bg_painspot.dc79c262.png";